import { ASSETS, SITE } from "@/lib/brand";

const NAV = [
  ["Services", "#services"],
  ["Audit", "#audit"],
  ["Process", "#process"],
  ["Use Cases", "#use-cases"],
  ["Insights", "/insights"],
  ["Privacy", "/privacy"],
  ["Terms", "/terms"],
  ["Contact", "#contact"],
];

export default function Footer() {
  return (
    <footer
      id="contact"
      style={{
        borderTop: "1px solid var(--line)",
        background: "var(--bg-deep)",
        padding: "64px 24px 40px",
      }}
      data-testid="footer"
    >
      <div className="container-edge">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1.4fr) minmax(0, 1fr)",
            gap: 40,
            paddingBottom: 48,
            borderBottom: "1px solid var(--line)",
          }}
          className="footer-grid"
        >
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 18,
              }}
            >
              <img
                src={ASSETS.logoLight}
                alt="ForgeLayer AI"
                width="38"
                height="38"
                loading="lazy"
                decoding="async"
                style={{ width: 38, height: 38, objectFit: "contain" }}
                data-testid="footer-logo"
              />
              <div
                className="font-display"
                style={{
                  color: "#fff",
                  fontSize: 14,
                  fontWeight: 500,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                FORGELAYER
                <span style={{ color: "var(--accent)", marginLeft: 4 }}>AI</span>
              </div>
            </div>
            <p
              style={{
                color: "var(--silver)",
                fontSize: 14,
                lineHeight: 1.6,
                maxWidth: 460,
                margin: 0,
              }}
              data-testid="footer-description"
            >
              ForgeLayer AI identifies, designs and builds practical AI systems
              for real business growth.
            </p>
            <div className="footer-contact" data-testid="footer-contact">
              <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a>
              <a href={SITE.url} target="_blank" rel="noreferrer">
                {SITE.domain}
              </a>
            </div>
          </div>

          <div>
            <div
              className="font-mono"
              style={{
                color: "var(--muted)",
                fontSize: 11,
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                marginBottom: 16,
              }}
            >
              Navigate
            </div>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 10,
              }}
            >
              {NAV.map(([t, href]) => (
                <li key={t}>
                  <a
                    href={href}
                    className="footer-link"
                    data-testid={`footer-link-${t.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          style={{
            paddingTop: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            color: "var(--muted)",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 11,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <span data-testid="footer-copyright" style={{ textTransform: "none", letterSpacing: "0.02em", fontFamily: "Space Grotesk, sans-serif" }}>
            © 2026 ForgeLayer AI. All rights reserved.
          </span>
          <span>{SITE.url.replace("https://", "")}</span>
        </div>
      </div>

      <style>{`
        .footer-link,
        .footer-contact a {
          color: var(--ink-soft);
          font-family: "Space Grotesk", sans-serif;
          font-size: 14px;
          text-decoration: none;
          transition: color 200ms ease;
        }
        .footer-link:hover,
        .footer-contact a:hover { color: #fff; }
        .footer-contact {
          display: flex;
          flex-wrap: wrap;
          gap: 10px 18px;
          margin-top: 18px;
        }
        @media (max-width: 720px) {
          .footer-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
        }
      `}</style>
    </footer>
  );
}
